export default {
  status: {
    all: 'Todos',
    notEmitted: 'Não emitido',
    pending: 'Pendente de emissão',
    error: 'Erro de emissão'
  }
}